import { useRouter } from "next/router";
import React, { use, useEffect, useState } from "react";
import axiosClient from "../../utils/axiosClient";
import "./style.css";
import Head from "next/head";
import { Breadcrumb } from "antd";

const DynamicRouteDisplay = () => {
  const router = useRouter();
  const { pathname, query } = router;
  const { industry, slug, categoryPage, type } = query;
  const categorySlug = slug ? slug[0] || null : null;
  const typeSlug = slug ? slug[1] || null : null;
  const [industries, setIndustries] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [categoryModel, setCategoryModel] = useState({ data: [] });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [typeModel, setTypeModel] = useState({ data: [] });
  const [selectedType, setSelectedType] = useState(null);

  const isInventoryPage = pathname === "/Inventory";

  console.log(router.query);
  console.log("Type Slug", type);

  useEffect(() => {
    fetchIndustries();
    categoriesList();
    fetchTypes();
  }, [router]);

  useEffect(() => {
    if (industry) {
      // debugger;
      const matchingIndustry = industries.find(
        (item) => item.slugName === industry
      );
      if (matchingIndustry) {
        setSelectedIndustry(matchingIndustry);
      }
      if (categorySlug) {
        console.log("Category Slug", categorySlug);
        const matchingVal = categoryModel.data.find(
          (item) => item.slugName === categorySlug
        );
        console.log("Matching Val", matchingVal);
        if (matchingVal) {
          setSelectedCategory(matchingVal);

          if (typeSlug) {
            console.log(">>>>>", typeSlug);
            const typeVal = typeModel.data.find(
              (item) => item.slugName === typeSlug
            );
            console.log("Type Val", typeVal);
            if (typeVal) {
              setSelectedType(typeVal);
            } else {
              setSelectedType(null);
            }
          }
        } else {
          setSelectedCategory(null);
        }
      }
    }
  }, [industries, categoryModel, typeModel]);

  useEffect(() => {
    if (categoryPage) {
      console.log(categoryPage);
      console.log("INside Category Page");
      const matchingVal = categoryModel.data.find(
        (item) => item.slugName === categoryPage
      );

      if (matchingVal) {
        setSelectedCategory(matchingVal);
        console.log("Selected Category", selectedCategory);

        if (typeSlug) {
          const typeVal = typeModel.data.find(
            (item) => item.slugName === typeSlug
          );
          if (typeVal) {
            setSelectedType(typeVal);
            console.log("Selected Type", selectedType);
          } else {
            setSelectedType(null);
          }
        }
      } else {
        setSelectedCategory(null);
      }
    }
  }, [categoryModel, typeModel]);

  useEffect(() => {
    if (type) {
      const typeVal = typeModel.data.find((item) => item.slugName === type);
      if (typeVal) {
        setSelectedType(typeVal);
      } else {
        setSelectedType(null);
      }
    }
  }, [typeModel]);

  const fetchIndustries = async () => {
    try {
      const response = await axiosClient.get("GetAllIndustry");
      setIndustries(response || []);
    } catch {
      setIndustries([]);
    }
  };
  const categoriesList = async () => {
    try {
      const { industry } = router.query;
      const url = industry
        ? `GetAllCategoryByIndustry/${industry}`
        : "GetAllCategory";
      const res = await axiosClient.get(url);

      if (res) {
        setCategoryModel({ data: res });
        // console.log(">>>>Res Code", res);
        // console.log("Category Model Res", categoryModel);
        // console.log("Category Model Data", categoryModel.data);
      } else {
        setCategoryModel({ data: [] });
      }
    } catch (error) {
      console.log("Error fetching categories:", error);
      setCategoryModel({ data: [] });
    }
  };

  // console.log("Selected Industry", selectedIndustry.slugName);
  // console.log("Selected Category", selectedCategory);

  const fetchTypes = async () => {
    try {
      let url = "GetAllType";
      if (industry && categorySlug) {
        url = `GetAllTypeByIndustryCategory/${industry}/${categorySlug}`;
      } else if (categorySlug) {
        url = `GetAllTypeByCategory/${categorySlug}`;
      }

      // console.log("url ===>", url);

      const res = await axiosClient.get(url);
      // console.log("res ===>", res);
      if (res) {
        setTypeModel({ data: res });
      } else {
        setTypeModel({ data: [] });
      }
    } catch (error) {
      console.log("Error fetching types:", error);
      setTypeModel({ data: [] });
    }
  };

  return (
    <div>
      <Head>
        <title>{industry ? selectedIndustry?.name : "Inventory"}</title>
      </Head>
      {isInventoryPage ? (
        <h1 className="breadcrums-title">Inventory</h1>
      ) : (
        <div className="desktop-breadcrumbs">
          <h1 className="breadcrums-title">
            {/* Handle routes like /fashion-apparel, /fashion-apparel/safety-pants */}
            {industry ? (
              <>
                {selectedIndustry?.name}
                {selectedCategory ? ` / ${selectedCategory?.name}` : null}
                {selectedType ? ` / ${selectedType?.name}` : null}
              </>
            ) : null}

            {/* Handle routes like /category/adhesives */}
            {categoryPage ? `${selectedCategory?.name}` : null}

            {/* Handle routes like /type/socket-meter */}
            {selectedType ? `${selectedType.name}` : null}
          </h1>
          <Breadcrumb separator={"/"}>
            <Breadcrumb.Item href="/"> Home </Breadcrumb.Item>
            {/* <Breadcrumb.Item href={`/${selectedIndustry?.slugName}`}>
              {" "}
              {industry ? selectedIndustry?.name : "Inventory"}
            </Breadcrumb.Item>
            {selectedCategory ? (
              <Breadcrumb.Item href={selectedCategory.slugName}>
                {selectedCategory?.name}
              </Breadcrumb.Item>
            ) : null} */}
            {/* {categoryPage && (
              <Breadcrumb.Item href={`/category/${categoryPage}`}>
                {categoryPage}
              </Breadcrumb.Item>
            )} */}
            {selectedIndustry && (
              <Breadcrumb.Item href={`/${selectedIndustry.slugName}`}>
                {selectedIndustry.name}
              </Breadcrumb.Item>
            )}

            {selectedCategory && (
              <Breadcrumb.Item href={`/category/${selectedCategory.slugName}`}>
                {selectedCategory.name}
              </Breadcrumb.Item>
            )}

            {selectedType ? (
              <Breadcrumb.Item href={`/type/${selectedType.slugName}`}>
                {selectedType?.name}
              </Breadcrumb.Item>
            ) : null}
          </Breadcrumb>
        </div>
      )}
      {/* <hr></hr> */}
    </div>
  );
};

export default DynamicRouteDisplay;
